/* eslint-disable max-len */
import React from 'react';

export function RunTestBell(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 64 64" {...props}>
      <g clipPath="url(#clip0_1481_2636)">
        <rect width="64" height="64" fill="#525266" rx="32"></rect>
        <path
          fill="url(#paint0_linear_1481_2636)"
          fillRule="evenodd"
          d="M31.12 38.44c7.56 4.342 13.07 8.913 12.313 10.213-.758 1.3-7.493-1.16-15.053-5.502-7.552-4.335-13.062-8.906-12.312-10.206.758-1.3 7.493 1.16 15.053 5.502v-.008z"
          clipRule="evenodd"
        ></path>
        <path
          fill="url(#paint1_linear_1481_2636)"
          fillRule="evenodd"
          d="M43.572 17a3.035 3.035 0 011.122 4.157 3.07 3.07 0 01-4.181 1.116 3.035 3.035 0 01-1.121-4.158A3.07 3.07 0 0143.572 17z"
          clipRule="evenodd"
        ></path>
        <path
          fill="url(#paint2_linear_1481_2636)"
          d="M28.744 42.202c1.19.42 2.66-.666 3.281-2.425.622-1.76.161-3.526-1.03-3.946-1.19-.42-2.659.666-3.28 2.425-.622 1.76-.161 3.526 1.03 3.946z"
        ></path>
        <path
          fill="url(#paint3_linear_1481_2636)"
          fillRule="evenodd"
          d="M43.344 47.81c-.267-.754-.787-2.822.148-5.635.862-2.585 2.585-7.016 3.46-9.246.216-.45.395-.901.543-1.366a10.895 10.895 0 00-4.983-12.732c-4.537-2.607-10.173-1.617-13.574 2.068-.327.369-.639.746-.921 1.152-1.508 1.876-4.508 5.568-6.327 7.606-1.975 2.208-4.047 2.8-4.827 2.94 2.117-.133 7.901 2.185 14.265 5.841 6.364 3.655 11.28 7.473 12.223 9.364l-.007.008z"
          clipRule="evenodd"
        ></path>
        <path
          stroke="url(#paint4_linear_1481_2636)"
          strokeOpacity="0.4"
          d="M42.995 47.023a11.23 11.23 0 00-.966-1.06c-.698-.686-1.604-1.458-2.678-2.284-2.148-1.652-4.972-3.523-8.159-5.353-3.185-1.83-6.228-3.326-8.74-4.349-1.257-.511-2.382-.905-3.328-1.163a11.302 11.302 0 00-1.419-.302c1.022-.334 2.58-1.092 4.081-2.77 1.822-2.04 4.824-5.736 6.331-7.61l.003-.005.003-.003c.278-.4.586-.772.91-1.14 3.362-3.64 8.932-4.618 13.415-2.042a10.767 10.767 0 014.924 12.581c-.147.46-.322.905-.535 1.35l-.002.004-.002.004c-.876 2.23-2.6 6.664-3.463 9.253-.708 2.129-.593 3.839-.375 4.89z"
        ></path>
        <g filter="url(#filter0_d_1481_2636)">
          <path
            fill="url(#paint5_linear_1481_2636)"
            fillRule="evenodd"
            d="M29.795 26.595c3.195 0 5.808-2.603 5.808-5.801S32.99 15 29.795 15s-5.808 2.603-5.808 5.801 2.606 5.8 5.808 5.8v-.006z"
            clipRule="evenodd"
          ></path>
          <mask
            id="mask0_1481_2636"
            style={{ maskType: 'luminance' }}
            width="4"
            height="6"
            x="28"
            y="17"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#fff" d="M31.49 17.66h-3.388v5.317h3.388V17.66z"></path>
          </mask>
          <g mask="url(#mask0_1481_2636)">
            <path
              fill="#fff"
              d="M31.363 22.399v.578h-2.837v-.578h1.084v-3.198c0-.113.004-.229.011-.347l-.835.691a.295.295 0 01-.112.057.261.261 0 01-.105 0 .341.341 0 01-.086-.032.245.245 0 01-.058-.053l-.242-.333 1.568-1.323h.633V22.4h.98z"
              opacity="0.76"
            ></path>
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_1481_2636"
          width="59.617"
          height="59.602"
          x="9.987"
          y="1"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dx="10" dy="10"></feOffset>
          <feGaussianBlur stdDeviation="12"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.133333 0 0 0 0 0.160784 0 0 0 0 0.192157 0 0 0 0.24 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1481_2636"></feBlend>
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1481_2636" result="shape"></feBlend>
        </filter>
        <linearGradient
          id="paint0_linear_1481_2636"
          x1="24.895"
          x2="37.258"
          y1="47.892"
          y2="35.002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E6E8F"></stop>
          <stop offset="1" stopColor="#484856"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1481_2636"
          x1="42.191"
          x2="41.852"
          y1="22.001"
          y2="16.603"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9A9B9"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1481_2636"
          x1="30.996"
          x2="28.748"
          y1="35.831"
          y2="42.203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73738F"></stop>
          <stop offset="1" stopColor="#21212D"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1481_2636"
          x1="32.432"
          x2="32.432"
          y1="47.809"
          y2="17.368"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BEBECC"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1481_2636"
          x1="24.23"
          x2="41.497"
          y1="5.008"
          y2="46.476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0.23"></stop>
          <stop offset="0.743" stopColor="#FCFCFC" stopOpacity="0.08"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_1481_2636"
          x1="23.987"
          x2="35.603"
          y1="20.801"
          y2="20.801"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD2476"></stop>
          <stop offset="1" stopColor="#FF512F"></stop>
        </linearGradient>
        <clipPath id="clip0_1481_2636">
          <rect width="64" height="64" fill="#fff" rx="32"></rect>
        </clipPath>
      </defs>
    </svg>
  );
}
